import React from 'react';
import { ErrorContainer, ErrorMsg, ErrorIcon, ErrorHeading } from './ApiErrorStyles';
import { ClickText, GenericP } from '../Styles';
import { getXrequestId } from 'UtilityComponents/Util';

const ApiError = (props) => {
	const { text4 = 'Kindly', heading = 'Uh Oh!', text1 = 'It looks like our server is not responding at the moment.', text2, text3, ctatext = 'refresh the page', clickAction, headSize, textSize, txtAlign } = props;
	const clickHandler = () => {
		if (clickAction) {
			clickAction();
		} else {
			window.location.reload();
		}
	};
	return (
		<ErrorContainer {...props}>
			<ErrorIcon {...props} />
			<ErrorMsg {...props}>
				<ErrorHeading fsize={headSize}>{heading}</ErrorHeading>
				<GenericP text_align={txtAlign} fsize={textSize + 'px'}>
					{text1}
				</GenericP>
				{getXrequestId() &&
				<GenericP text_align={txtAlign} top_M='5' bottom_M='5'>
					code: {getXrequestId()}
				</GenericP>}
				{text2 ?
					<GenericP text_align={txtAlign} fsize={textSize + 'px'}>
						{text2}
					</GenericP> :
					<GenericP text_align={txtAlign} fsize={textSize + 'px'}>
						{text4} <b><ClickText f_size={textSize} onClick={clickHandler}>{ctatext}</ClickText></b>
						<span>{text3}</span>
					</GenericP>}
			</ErrorMsg>
		</ErrorContainer>
	);
};

export default ApiError;
